import { render, staticRenderFns } from "./ChartTempoRessuprimento.vue?vue&type=template&id=056185ca"
import script from "./ChartTempoRessuprimento.vue?vue&type=script&lang=js"
export * from "./ChartTempoRessuprimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports